module.exports = __webpack_public_path__ + "img/logo2.e13bdc2f.png";